export default __webpack_public_path__ + "6c9f40a7ede75a62451f229a627ada59.svg";